import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

export function getEcho() {
  window.Pusher = Pusher;
  const broadcastDriver = process.env.VUE_APP_WEB_SOCKET_DRIVER || 'reverb';

  let echoConfig = {
    broadcaster: 'reverb',
    key: process.env.VUE_APP_REVERB_WEB_SOCKET_KEY,
    wsHost: process.env.VUE_APP_REVERB_WEB_SOCKET_HOST || '127.0.0.1',
    wsPort: process.env.VUE_APP_REVERB_WEB_SOCKET_PORT || 8080,
    wssPort: process.env.VUE_APP_REVERB_WEB_SOCKET_PORT || 8080,
    forceTLS: false,
    enabledTransports: ['ws', 'wss'],
  };
  
  console.log(`[Echo] Initializing with broadcaster: ${broadcastDriver}`, echoConfig);
  const echo = new Echo(echoConfig);
  window.Echo = echo;
  
  return echo;
}









